import * as L from 'leaflet';

export const cameraIcon = new L.Icon({
  iconUrl: 'assets/camera-outline.svg',
  iconSize: [42, 42],
  popupAnchor: [1, -42],
  shadowSize: [42, 42],
});
